module.exports = __webpack_public_path__ + "static/getstarted-f39a5255c81376188b6133ee60eafde4.mp4";